import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import get from 'lodash/get';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import ButtonsContainer from 'components/Form/ButtonsContainer';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import messages from '../../messages';
import validatorRules from './validatorRules.json';
const formName = constants.ELEVATE_PERMISSIONS_FORM;
const ElevatePermissionsForm = ({ onCancel })=>{
    const formValues = useSelector(App.selectors.formSelector(formName));
    const isClean = !get(formValues, 'originalValues');
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const elevatePermissions = useAction(actions.elevatePermissions);
    const clearForm = useAction(App.actions.clearForm, formName);
    const onSetFormValue = useAction(App.actions.setFormValue, formName);
    useEffect(()=>()=>{
            clearForm();
        }, []);
    const submitForm = ({ password })=>{
        elevatePermissions({
            password
        });
    };
    const processForm = App.hooks.useFormProcessing(formName, submitForm);
    const onSubmit = ()=>{
        processForm(formValues, validatorRules);
    };
    const renderField = (id)=>/*#__PURE__*/ _jsx(FormGroup, {
            id: id,
            labelMessage: messages.labels[id],
            formValues: formValues,
            isOneLiner: !isMobileDisplayMode,
            children: /*#__PURE__*/ _jsx(Input, {
                type: "password",
                placeholder: messages.placeholders[id],
                onChange: onSetFormValue
            })
        });
    const renderActions = ()=>/*#__PURE__*/ _jsx(ButtonsContainer, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row flex-column-reverse flex-sm-row",
                children: [
                    onCancel && /*#__PURE__*/ _jsx("div", {
                        className: isMobileDisplayMode ? 'col-12' : 'col-6',
                        children: /*#__PURE__*/ _jsx(Button, {
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.cancel,
                            className: "btn--block",
                            onClick: onCancel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: isMobileDisplayMode ? 'col-12' : 'col-6',
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.continue,
                            className: "btn--block btn--filled",
                            isDisabled: isClean
                        })
                    })
                ]
            })
        });
    return /*#__PURE__*/ _jsxs(Form, {
        className: "form",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: renderField('password')
            }),
            renderActions()
        ]
    });
};
export default ElevatePermissionsForm;
